var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('button',{staticClass:"voucher-btn",on:{"click":_vm.handleClick}},[_c('i',{staticClass:"material-icons vtd-icon-2 vtd-mr-3"},[_vm._v("attach_file")]),_c('span',[_vm._v("View Voucher")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }